(function () {
    'use strict';

    angular.module('gov.filters')
           .filter('govDate', govDate);

    govDate.$inject = ['$filter'];

    function govDate($filter) {
        var dateFilter = $filter('date');
        return function (theDate, format) {
            if (format && format === 'datetime') {
                return dateFilter(theDate, 'yyyy-MM-dd hh:mm a');
            }
            return dateFilter(theDate, 'MMMM d, yyyy');
        }
    }
})();